function stringToColor(string: string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

export default function stringAvatar(name: string | undefined) {
  let nameAbbreviation = "U";
  if (name === undefined)
    return {
      sx: {
        backgroundColor: "#ffcc00",
      },
      children: `${nameAbbreviation}`,
    };
  const nameParts = name.split(" ");
  nameAbbreviation =
    nameParts.length > 1 ? nameParts[0][0] + nameParts[1][0] : nameParts[0][0];
  return {
    sx: {
      backgroundColor: stringToColor(name),
    },
    children: `${nameAbbreviation}`,
  };
}
